import React from 'react';

type Status = 'ready' | 'attention' | 'critical' | string;

const MAP: Record<string, { label: string; className: string }> = {
  ready: {
    label: 'Configuración completa',
    className: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  },
  attention: {
    label: 'Requiere atención',
    className: 'bg-amber-50 text-amber-900 ring-amber-200',
  },
  critical: {
    label: 'No configurado',
    className: 'bg-rose-50 text-rose-800 ring-rose-200',
  },
  valid: {
    label: 'Válido',
    className: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  },
  expiring_soon: {
    label: 'Por vencer',
    className: 'bg-amber-50 text-amber-900 ring-amber-200',
  },
  expired: {
    label: 'Expirado',
    className: 'bg-rose-50 text-rose-800 ring-rose-200',
  },
  missing: {
    label: 'Sin certificado',
    className: 'bg-slate-100 text-slate-600 ring-slate-200',
  },
  TEST: {
    label: 'TesteCF',
    className: 'bg-sky-50 text-sky-800 ring-sky-200',
  },
  CERTIFICATION: {
    label: 'Certificación',
    className: 'bg-indigo-50 text-indigo-800 ring-indigo-200',
  },
  PRODUCTION: {
    label: 'Producción',
    className: 'bg-violet-50 text-violet-800 ring-violet-200',
  },
};

export const FiscalStatusBadge: React.FC<{ status?: Status | null; label?: string }> = ({
  status,
  label,
}) => {
  const key = status || 'missing';
  const meta = MAP[key] || {
    label: label || String(key),
    className: 'bg-slate-100 text-slate-700 ring-slate-200',
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${meta.className}`}
    >
      {label || meta.label}
    </span>
  );
};

export default FiscalStatusBadge;
